import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './router/Router';
import { useEffect, useState } from 'react';
import Loader from './components/Loader';
import StagingGate from './components/StagingGate';
import { ConsentProvider } from './contexts/ConsentContext';
import CookieConsent from './components/redesign/CookieConsent';
import useAnalytics from './hooks/useAnalytics';

const AnalyticsProvider = ({ children }) => {
    useAnalytics();
    return children;
};

const App = () => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setLoading(false);
        }, 400);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);


    return (
        <ConsentProvider>
            <StagingGate>
                <BrowserRouter>
                    <AnalyticsProvider>
                        {loading && <Loader />}
                        <Router setLoading={setLoading} />
                        <CookieConsent />
                    </AnalyticsProvider>
                </BrowserRouter>
            </StagingGate>
        </ConsentProvider>
    );
}

export default App;
